
export async function post(url, data) {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json',
        }
        const session = sessionStorage.getItem('session')
        if (session != null) headers['Session'] = session
        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status == 200) resp.status = 0
                resolve(resp)
            })
            .catch((e) => resolve({ status: 99, message: e }))
    })
}